import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
export default class TwoFactorGridItem extends Component {
  view() {
    const _this$attrs = this.attrs,
      iconName = _this$attrs.icon,
      title = _this$attrs.title,
      value = _this$attrs.value,
      action = _this$attrs.action,
      helpText = _this$attrs.helpText;
    return m("li", {
      className: "TwoFactorGrid-item"
    }, m("span", {
      className: "TwoFactorGrid-icon"
    }, m(Icon, {
      name: iconName
    })), m("div", {
      className: "TwoFactorGrid-content"
    }, m("span", {
      className: "TwoFactorGrid-title"
    }, title), m("span", {
      className: "TwoFactorGrid-value"
    }, value), helpText && m("span", {
      className: "helpText TwoFactorGrid-helpText"
    }, helpText)), action && m("span", {
      className: "TwoFactorGrid-actions"
    }, action));
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorGridItem', TwoFactorGridItem);